import { getIpfsUrl } from "./ipfs";

const normalizePossibleUrl = (value) => {
  if (typeof value !== "string") return "";
  const trimmed = value.trim();
  if (!trimmed) return "";

  if (trimmed.startsWith("ipfs://")) {
    const cid = trimmed.replace("ipfs://", "").replace(/^ipfs\//, "");
    return cid ? getIpfsUrl(cid) : "";
  }

  return trimmed;
};

const firstNonEmptyString = (values) =>
  values.find((value) => typeof value === "string" && value.trim() !== "") || "";

const extractLogoFromAttachments = (attachments) => {
  if (!Array.isArray(attachments)) return "";

  const logoAttachment = attachments.find((att) => {
    const key = att?.questionKey || att?.question_key || att?.key;
    return key === "q11_company_logo";
  });

  if (!logoAttachment) return "";

  const directUrl = firstNonEmptyString([
    logoAttachment.presignedUrl,
    logoAttachment.presigned_url,
    logoAttachment.url,
    logoAttachment.file_url,
    logoAttachment.publicUrl,
    logoAttachment.public_url,
    logoAttachment.fileUrl,
    logoAttachment.downloadUrl,
    logoAttachment.download_url,
  ]);

  if (directUrl) return normalizePossibleUrl(directUrl);

  const cid = firstNonEmptyString([
    logoAttachment.cid,
    logoAttachment.ipfsCid,
    logoAttachment.ipfs_cid,
    logoAttachment.logoCid,
    logoAttachment.logo_cid,
  ]);

  return cid ? getIpfsUrl(cid.trim()) : "";
};

export const resolveCompanyLogoUrl = (entity) => {
  if (!entity || typeof entity !== "object") return "";

  const directUrl = firstNonEmptyString([
    entity.logoUrl,
    entity.logo_url,
    entity.companyLogoUrl,
    entity.company_logo_url,
    entity.logo,
    entity.brandLogo,
    entity.brand_logo,
    entity.entityLogoUrl,
    entity.entity_logo_url,
    entity.company?.logo,
    entity.company?.logoUrl,
    entity.company?.logo_url,
    entity.company?.logo?.url,
    entity.company?.logo?.publicUrl,
    entity.company?.logo?.presignedUrl,
    entity.company?.logo?.presigned_url,
    entity.certification?.logoUrl,
    entity.certification?.logo_url,
    entity.publicCertification?.logoUrl,
    entity.publicCertification?.logo_url,
  ]);

  if (directUrl) {
    return normalizePossibleUrl(directUrl);
  }

  const logoCid = firstNonEmptyString([
    entity.logoCID,
    entity.logoCid,
    entity.logo_cid,
    entity.companyLogoCID,
    entity.companyLogoCid,
    entity.company_logo_cid,
    entity.company?.logoCID,
    entity.company?.logoCid,
    entity.company?.logo_cid,
    entity.certification?.logoCid,
    entity.certification?.logoCID,
    entity.certification?.logo_cid,
    entity.publicCertification?.logoCid,
    entity.publicCertification?.logoCID,
    entity.publicCertification?.logo_cid,
  ]);

  if (logoCid) {
    return getIpfsUrl(logoCid.trim());
  }

  const attachmentLogoUrl =
    extractLogoFromAttachments(entity.attachments) ||
    extractLogoFromAttachments(entity.company?.attachments) ||
    extractLogoFromAttachments(entity.certification?.attachments) ||
    extractLogoFromAttachments(entity.publicCertification?.attachments);

  return attachmentLogoUrl || "";
};
